import Swiper, { A11y, Navigation, Pagination } from 'swiper';
import { isAtLeast } from '../utils/_breakpoints.js';

class mPdpImages extends HTMLDivElement {
    constructor() {
        super();
        this.sliderInitialised = false;
        this.slider = null;
        this.nextButton = this.querySelector('.btn-next');
        this.prevButton = this.querySelector('.btn-prev');
        // bind this to theses functions :
        this.initSlider = this.initSlider.bind(this);
        this.loadNewInstance = this.loadNewInstance.bind(this);
    }

    connectedCallback() {
        if (!isAtLeast('md')) {
            this.initSlider(); // init slider on pageload on mobile
        } else {
            this.nextButton.addEventListener('click', this.initSlider);
            this.prevButton.addEventListener('click', this.initSlider);
        }
        this.initZooming();
        document.addEventListener('mPdpImages:reload', this.loadNewInstance); // reload image event comes from base.js
    }

    disconnectedCallback() {
        // remove reload event as this component is regenerated (otherwise it will stay and generate console errors)
        document.removeEventListener('mPdpImages:reload', this.loadNewInstance);
    }

    initSlider(e) {
        if (!this.sliderInitialised) {
            // Save original html to be used in m-fullscreen-images for zoomable images
            this.originalHtml = this.querySelector('.swiper-wrapper').innerHTML;

            this.slider = new Swiper(this, {
                modules: [A11y, Navigation, Pagination],
                initialSlide: 0,
                loop: false,
                allowTouchMove: true,
                resistance: false,
                navigation: {
                    nextEl: '.btn-next',
                    prevEl: '.btn-prev',
                },
                a11y: {
                    prevSlideMessage: this.dataset.a11ySlidePrev,
                    nextSlideMessage: this.dataset.a11ySlideNext,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                preventInteractionOnTransition: true,
                on: {
                    afterInit: () => {
                        if (e) {
                            if (e.currentTarget.classList.value.includes('next')) {
                                this.swiper.slideNext();
                            } else if (e.currentTarget.classList.value.includes('prev')) {
                                this.swiper.slidePrev();
                            }
                        }
                        this.nextButton.removeEventListener('click', this.initSlider);
                        this.prevButton.removeEventListener('click', this.initSlider);
                    },
                    activeIndexChange: this.updateSlideVideoClass.bind(this),
                },
            });
            this.updateSlideVideoClass();

            this.sliderInitialised = true;
        }
    }

    initZooming() {
        const images = this.querySelectorAll('.pdp-zoom-trigger img');
        const imagesBtn = this.querySelectorAll('.pdp-zoom-trigger');
        for (const image of images) {
            image.addEventListener('click', (e) => { this.zoomImage(e.currentTarget); });
        }

        for (const imageBtn of imagesBtn) {
            imageBtn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ' || e.key === 32) {
                    this.zoomImage(e.currentTarget);
                }
            });
        }

        // Listen to zoom event from m-tile-video
        const slideVideoList = this.querySelectorAll('[is="m-tile-video"]');
        slideVideoList.forEach((slideEl) => {
            slideEl.addEventListener('fullscreen', (event) => {
                this.zoomImage(event.detail.videoEl);
            });
        });
    }

    zoomImage(currentImage) {
        document.dispatchEvent(new CustomEvent('oFullScreenImages:showZoom', {
            detail: {
                imagesContainer: this,
                currentImage,
            },
        }));
    }

    loadNewInstance(e) {
        const { productImagesHtml } = e.detail;
        if (productImagesHtml) {
            this.insertAdjacentHTML('beforebegin', productImagesHtml); // insert new instance of m-pdp-images
            this.parentNode.removeChild(this); // this instance deletes herself from the DOM
            // fcplayer.js scans the DOM on its own load; a .freecaster-player injected afterwards
            // (variant change) needs a manual rescan if the SDK exposes one. To verify in sandbox
            // against the actual fcplayer.js API.
            if (window.FCPlayer && typeof window.FCPlayer.scan === 'function') {
                window.FCPlayer.scan();
            }
        }
    }

    updateSlideVideoClass() {
        const slideEl = this.swiper.slides[this.swiper.activeIndex];
        const videoEl = slideEl.querySelector('video, .freecaster-player');
        if (videoEl) {
            this.classList.add('slide-video-active');
        } else {
            this.classList.remove('slide-video-active');
        }
    }
}

customElements.define('m-pdp-images', mPdpImages, {
    extends: 'div',
});
